import React, { useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import styled from 'styled-components';
import { NavLink } from "react-router-dom";
import NotLoggedLayout from 'layouts/NotLoggedLayout';
import { getUser, setUser } from 'helpers/user';
import { assets } from 'helpers/generic';
import Auth from 'services/Auth';
import { toast } from "react-toastify";
import CristalLoader from "components/CristalLoader";

const LoginStyled = styled.div` 
	margin-top: 50px;
	margin-bottom: 50px;

	#left {
		color: white;
		margin-bottom: 40px;

		h2 {
			text-align: center;
			font-size: 15px;
			margin-top: 40px;
		}

		h1 {
			text-align: center;
			font-size: 45px;
			margin-bottom: 40px;
		}

		p {
			display: block;
			margin: 0 auto;
			max-width: 300px;
			margin-bottom: 10px;
			text-align: center;
			font-size: 17px;
		}

		a {
			margin-top: 45px;
		}

		a.privacy-link {
			text-decoration: none;
			font-style: none;
			color: white;
			font-size: 14px;
		}
	}

	#right {
		#login-form {
			background: white;
			max-width: 400px;
			margin: 0 auto;
			padding-top: 100px;
			padding-bottom: 100px;

			#logo {
				display: block;
				margin: 0 auto;
				max-width: 150px;
				margin-bottom: 60px;
			}

			.input-wrapper {
				max-width: 300px;
				margin: 0 auto;
				margin-bottom: 20px;
			}

			button {
				margin-top: 40px;
			}

			p {
				font-size: 14px;
				margin-bottom: 25px;
			}

			.recover-link-wrapper {				
				margin-top: 20px;
				text-align: center;

				button {
					font-size: 14px;
					font-weight: 500;
					color: var(--plenoil-blue2);
					text-decoration: none;
					margin-top: 0px;

					.small {
						margin-right: 5px;
					}
				}
			}
		}

	}
	
`;

export default function Login() {
	// Refs
	const usernameRef = useRef(null);
	const passwordRef = useRef(null);
	const usernameRecoverRef = useRef(null);

	// State
	let [recoverPass, setRecoverPass] = useState(false);
	let [loading, setLoading] = useState(false);

	const login = async (e) => {
		e.preventDefault();

		setLoading(true);

		let result = await Auth.login(usernameRef.current.value, passwordRef.current.value);
		if (!result) {
			toast.error('Datos de acceso inválidos');
		} else {
			setUser({...result.user, accessToken: result.access_token}, true, true);
		}

		setLoading(false);
	};

	const recover = async (e) => {
		e.preventDefault();

		setLoading(true);

		let result = await Auth.recoverPassword(usernameRecoverRef.current.value);
		if (result === -1) {
			toast.warning('Has intentado solicitar una nueva contraseña demasiado rápido. Espera 1 minuto para intentarlo de nuevo.');
		}
		if (result === false) {
			toast.error('Datos de acceso inválidos');
		}
		if (result === true) {
			toast.success('Te hemos enviado un email con las instrucciones para recuperar tu contraseña');
			setRecoverPass(false);
			usernameRecoverRef.current.value = '';
		}
		
		setLoading(false);
	};

	if ( getUser() ) return <Navigate to="/" />;

	// Render
	return (
		<NotLoggedLayout>
			{loading && <CristalLoader />}
			<LoginStyled>
				<div className="row">
					<div id="left" className="col-md-6">
						<h2>ÁREA DE CLIENTES</h2>
						<h1>Bienvenido a Plenoil</h1>
						<p>
							Visualiza todas tus facturas y descárgalas en tu móvil<br />
							Echa un vistazo rápido a tus consumos por meses o por matrículas<br />
							Consulta el precio de todas nuestras estaciones
						</p>
						<p>
							¿Aún no tienes una cuenta en Plenoil?
						</p>
						<div className="text-center">
							<NavLink className="btn btn-plenoil btn-plenoil-white" to="/register">CREAR CUENTA</NavLink>
						</div>
						<div className="text-center mt-3">
							<a href="https://plenoil.es/politica-de-privacidad-plenoil/" className="privacy-link" target="_blank" rel="noreferrer"><u>Términos de uso</u> y <u>Política de privacidad</u></a>
						</div>
					</div>

					<div id="right" className="col-md-6">
						<div id="login-form" className="box-plenoil">
							<img src={assets('assets/img/Plenoil-logo-2022.svg')} alt="Plenoil Logo" id="logo" />

							{!recoverPass ?
								<React.Fragment>
									<div className="input-wrapper">
										<input ref={usernameRef} placeholder="NIF/CIF" type="text" className="input-plenoil" />
									</div>
									<div className="input-wrapper">
										<input ref={passwordRef} placeholder="Contraseña" type="password" className="input-plenoil" />
									</div>
									
									<div className="text-center">
										<button onClick={(e) => login(e)} className="btn btn-plenoil btn-plenoil-orange">INICIAR SESIÓN</button>
									</div>

									<div className="recover-link-wrapper">
										<button className="btn btn-link" onClick={() => setRecoverPass(true)}>¿Has olvidado tu contraseña?</button>
									</div>
								</React.Fragment>
								:
								<React.Fragment>
									<div className="text-center">
										<p>
											Introduce tu NIF/CIF para recibir un email con las<br />
											instrucciones para recuperar tu contraseña
										</p>
									</div>

									<div className="input-wrapper">
										<input ref={usernameRecoverRef} placeholder="NIF/CIF" type="text" className="input-plenoil" />
									</div>

									<div className="text-center">
										<button onClick={(e) => recover(e)} className="btn btn-plenoil btn-plenoil-orange">SOLICITAR NUEVA CONTRASEÑA</button>
									</div>

									<div className="recover-link-wrapper">
										<button className="btn btn-link" onClick={() => setRecoverPass(false)}><i className="bi bi-chevron-left small"></i> Volver atrás</button>
									</div>
								</React.Fragment>
							}
						</div>
					</div>
				</div>
			</LoginStyled>
		</NotLoggedLayout>
	);
}